import  ApiService  from '../../services/api.service'

const state = {
    response: {
        message: '',
        variant: '',
        errmsg: []
    },
    isShow: false,
    isProfileSuccess: false,
    loading: false,

    successResponse: {
        message: '',
        variant: ''
    },
    getprofileDetails: "",
}

const getters = {
    loading: state => state.loading,
    response: (state) => state.response,
    isShow: (state) => state.isShow,
    isProfileSuccess: (state) => state.isProfileSuccess,
    successResponse: (state) => state.successResponse,
    profileDetails:  (state) => state.getprofileDetails,
}

const actions = {
    async editProfileRequest({commit}, formdata) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true)

            ApiService.put('/account', formdata)
            .then(response => {
                commit('setProfileDetails', response.data)
                commit('auth/setUserDetails', response.data.userDetails, {root:true})
                commit('auth/setUserDetailsAddress', response.data.userAddress, {root:true})

                commit('setProfileUpdateSuccess', response)
                // commit('setSuccessResponse', response.data);
                resolve();
            })
            .catch(error => {

                commit('setResponse', error.response.data)
                commit('setError', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },

    async getProfileDetail({commit}, userid) {
        return new Promise((resolve, reject) => {
            commit('setLoading', true);
            commit('setIsShow', true)

            ApiService.get('/account')
            .then(response => {
                commit('setProfileDetails', response.data)
                // commit('setSuccessResponse', response.data);
                resolve();
            })
            .catch(error => {
                commit('setResponse', error.response.data)
                commit('setError', error.response.data)
                reject(error);
            })
            .finally(() => {
                commit('setLoading', false);
            });
        });
    },

    resetError({commit}) {
        commit('resetState')
    },
    showError({commit}, value) {
        commit('setError', value)
    },
}

const mutations = {
    setIsShow(state, isShow) {
        state.isShow = isShow
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setResponse(state, data) {

        state.response.message = data.message;
        if(data.success == true) {
            state.response.variant = 'success';
        } else {
            state.response.variant = 'danger';
        }
        /*if(data.success == false) {
            state.response.variant = 'danger';
        }*/
        
        // state.isProfileSuccess = false;
    },
    setError(state, data) {
        state.isShow = true;
        state.response.variant = 'danger';
        state.response.message = data.msg;
        state.response.errmsg = data;
        state.isProfileSuccess = false;
    },
    resetState(state) {
        state.isShow = false;
        state.response.variant = '';
        state.response.message = '';
        state.response.errmsg = [];

        state.successResponse.variant = '';
        state.successResponse.message = '';
        state.isProfileSuccess = false;
    },
    setSuccessResponse(state, data) {
        state.successResponse.message = "Success";
        if(data.success == true) {
            state.successResponse.variant = 'success';
        }
        state.isShow = false;
        state.isProfileSuccess = true;
    },
    setProfileUpdateSuccess(state, data) {
        
        state.response.message = data.data.message;
        state.response.variant = 'success';
        if(data.status == 200) {
            state.response.variant = 'success';
        }
        state.isShow = true;
    },
    setProfileDetails(state, data) { 
        state.getprofileDetails = data;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}